export default "__VITE_ASSET__dbd29978__"